import { ScreenCompanySelect } from '@dms/screen'

export default ScreenCompanySelect
